/**
 * Created by Sasha on 7/25/2018.
 */
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
@Injectable()
export class BlogService {
  constructor (private http: HttpClient, private api: AppConfig) {

  }

  getBlogs (page, perPage, blogTypes, blogVisibility, platformId, search,
            showOnlyForPlatform) {
    return this.http.get(this.api.baseUrl + '/blog/blogsNew?page=' + page + '&perPage=' + perPage +
      '&blogTypes=' + blogTypes + '&blogVisibility=' + blogVisibility + '&platformId=' + platformId
      + '&search=' + search + '&showOnlyForPlatform=' + showOnlyForPlatform, this.api.jsonTokenHeaders);
  }

  getBlogById(id) {
    return this.http.get(this.api.baseUrl + '/blog/blog?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteBlog(id) {
    return this.http.delete(this.api.baseUrl + '/blog/deleteBlog?id=' + id , this.api.jsonTokenHeaders);
  }

  getBlogTypes() {
    return this.http.get(this.api.baseUrl + '/blogType/blogTypes'  , this.api.jsonTokenHeaders);
  }

  addBlog(data) {
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[key] !== null) {
        formData.append(key, data[key]);
      }
    }
    return this.http.post(this.api.baseUrl + '/blog/addBlog' , formData , this.api.formDataHeaders);
  }

  getBlogForRecommendation(page = 1, perPage = 50, search) {
    return this.http.get(this.api.baseUrl + '/blog/blogForRecommendation?search=' + search + '&page=' +
      page + '&perPage=' + perPage, this.api.jsonTokenHeaders);
  }

  addRecommendation(data) {
    return this.http.post(this.api.baseUrl + '/recommendation/addRecommendation', data, this.api.jsonTokenHeaders);
  }

  removeRecommendation(id) {
    return this.http.get(this.api.baseUrl + '/recommendation/removeRecommendation?id=' + id, this.api.jsonTokenHeaders);
  }
}
